<template>
	<div>
		<!-- eslint-disable-next-line vue/no-mutating-props -->
		<v-dialog v-if="ttsDialog" v-model="ttsDialog" :max-width="size === 'sm' ? 295 : 395" persistent :retain-focus="false">
			<div :class="`${theme}-theme`" @click="cancelEvent" @dblclick="cancelEvent">
				<div class="popup pa-0">
					<div class="popup-header success pa-0 text-center">
						<div class="text-right pa-1">
							<v-btn class="close-icon" small icon @click="close">
								<v-icon size="18">{{ icons.mdiClose }}</v-icon>
							</v-btn>
							
						</div>
						<h4 class="fs--24 fw--600 popup-header-text">Text-to-Speech</h4>
					</div>
					<div class="popup-body">
						<div class="popup-content" :class="size === 'sm' && 'mt--2'">
							<v-row no-gutters align="center">
								<v-col :cols="size === 'sm' ? 12 : 4" :class="size === 'md' && 'pr-2'">
									<AssetsTTS :sticker="sticker" :list="false" :popupMd="true" />
								</v-col>

								<v-col :cols="size === 'sm' ? 12 : 8" :class="size === 'md' && 'pl-2'">
									<p class="fw--500 fs--14 mt-2 mb-2 white--text">
										Make this sticker talk by adding text!
									</p>

									<v-textarea
										v-model="text"
										style="color: white"
										background-color="base"
										rows="3"
										color="primary"
										placeholder="Enter your message..."
										:rules="[
											v => !!v || 'Message is required',
											v =>
												(!!v && v.length <= ttsMessageLength) ||
												`Maximum limit is ${ttsMessageLength} characters.`,
										]"
										:class="getThemeColor"
										no-resize
										outlined
										solo
										counter>
										<template v-slot:counter="item">
											<div class="fs--12 white--text counter">
												{{ item.props.value }} / {{ ttsMessageLength }}
											</div>
										</template>
									</v-textarea>
								</v-col>

								<v-col cols="12" v-if="!errorMessage">
									<v-btn
										block
										:disabled="!text || text.length > ttsMessageLength"
										color="primary"
										class="mt-1 action-btn text-uppercase py-7"
										@click="useSticker">
										<div class="d-flex justify-center flex-column">
											<strong class="fs--13">Play Now on Stream</strong>
											<div class="d-flex align-center justify-center">
												<img :src="getIcon(bitsValue)" width="15" alt="Bits" />
												<strong class="fs--13">{{ bitsValue }}</strong>
											</div>
										</div>
									</v-btn>
								</v-col>
								<v-col v-else>
									<p class="font-weight-bold" :class="getThemeColor">{{ errorMessage }}</p>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
			</div>
		</v-dialog>
	</div>
</template>

<script>
import { ref, computed } from 'vue';
import { useStore } from '@/store';
import axios from '@axios';
import { mdiClose } from '@mdi/js';
import { getBitIcon } from '@/utils/utils';
import AssetsTTS from '@/components/panel/Stickers/AssetsTTS.vue';

export default {
	components: {
		AssetsTTS,
	},
	props: {
		ttsDialog: {
			type: Boolean,
			default: false,
		},
		sticker: {
			type: Object,
			default: null,
		},
	},
	emits: ['useSticker'],
	setup(props, ctx) {
		const store = useStore();

		const text = ref('');
		const errorMessage = ref('');

		const ttsMessageLength = computed(() => {
			const config = JSON.parse(localStorage.getItem('panel_config'));
			if (config && config.ttsMessageMaxLength) {
				return config.ttsMessageMaxLength;
			}

			return 256;
		});

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		const getThemeColor = computed(() => {
			if (theme.value === 'red' || theme.value === 'pink') {
				return 'yellow--text';
			}

			return 'red--text';
		});

		const bitsValue = computed(() => {
			if (props.sticker.bits && props.sticker.bits !== 0) {
				return props.sticker.bits
					? props.sticker.bits.toLocaleString()
					: Number(props.sticker.sku.split('_')[1]).toLocaleString();
			}
			return 0;
		});

		const close = () => {
			ctx.emit('close');
		};

		const useSticker = () => {
			const payload = { text: text.value };
			errorMessage.value = null;

			axios.post('/tts-word-check', payload).then(res => {
				if (res.data.allowed) {
					ctx.emit('useSticker', text.value);
					text.value = ''
				} else {
					errorMessage.value = res.data.reason;
					setTimeout(() => {
						errorMessage.value = null;
					}, 5000);
				}
			});
		};

		const getIcon = (value) => {
			let bits = value
			if (typeof bits === 'string') {
				bits = Number(bits.replaceAll(',', ''))
			}

			return getBitIcon(bits);
		}

		const cancelEvent = event => {
			event.stopImmediatePropagation();
		};

		return {
			text,
			theme,
			size,
			close,
			bitsValue,
			cancelEvent,
			useSticker,
			getIcon,
			ttsMessageLength,
			getThemeColor,
			errorMessage,
			icons: {
				mdiClose,
			},
		};
	},
};
</script>

<style scoped>
.mt--2 {
	margin-top: -10px !important;
}

.counter {
	min-width: 60px !important;
	text-align: right;
}
</style>
